var _rect, _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 5.5,
    fill: "white",
    stroke: "#EAEAEC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.33333,
    cy: 3.33333,
    rx: 3.33333,
    ry: 3.33333,
    transform: "matrix(-1 0 0 1 23.3334 12.5)",
    stroke: "#6D6E7C",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 24.1122C14.1667 23.3952 14.6174 22.7557 15.2926 22.5145V22.5145C18.3367 21.4273 21.6633 21.4273 24.7074 22.5145V22.5145C25.3826 22.7557 25.8334 23.3952 25.8334 24.1122V25.2085C25.8334 26.198 24.9569 26.9581 23.9773 26.8182L23.6507 26.7715C21.2292 26.4256 18.7708 26.4256 16.3493 26.7715L16.0227 26.8182C15.0431 26.9581 14.1667 26.198 14.1667 25.2085V24.1122Z",
    stroke: "#6D6E7C",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewProfileIcon);
export default __webpack_public_path__ + "static/media/new-profile-icon.8079d59626a5a9ee8b25cc3fc94cefff.svg";
export { ForwardRef as ReactComponent };